var React = require('react');

function InvestorIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"72","height":"72","rx":"4","fill":"#F45C25","key":0}),React.createElement("path",{"d":"M35.9997 35.9997C38.9463 35.9997 41.333 33.613 41.333 30.6663C41.333 27.7197 38.9463 25.333 35.9997 25.333C33.053 25.333 30.6663 27.7197 30.6663 30.6663C30.6663 33.613 33.053 35.9997 35.9997 35.9997ZM35.9997 38.6663C32.4397 38.6663 25.333 40.453 25.333 43.9997V46.6663H46.6663V43.9997C46.6663 40.453 39.5597 38.6663 35.9997 38.6663Z","fill":"white","key":1})]);
}

InvestorIcon.defaultProps = {"width":"72","height":"72","viewBox":"0 0 72 72","fill":"none"};

module.exports = InvestorIcon;

InvestorIcon.default = InvestorIcon;
